import script from "./SendEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendEmail.vue?vue&type=script&lang=ts&setup=true"

import "./SendEmail.vue?vue&type=style&index=0&id=550ead2a&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550ead2a"]])

export default __exports__